import { NotFoundRouteProps } from '@tanstack/react-router'

import { InternalLinkButton } from '@/ui/atoms/link-button/LinkButton'
import { ErrorLayout } from '@/ui/layouts/ErrorLayout'

interface NotFoundComponentProps extends NotFoundRouteProps {
  fullScreen?: boolean
}

export function NotFoundComponent({ fullScreen }: NotFoundComponentProps) {
  return (
    <ErrorLayout fullScreen={fullScreen}>
      <div className="my-auto flex flex-col items-center justify-center gap-6 py-8">
        <div className="typography-display-2 text-secondary">404</div>
        <h2 className="typography-heading-4">The requested page could not be found.</h2>
        <InternalLinkButton to="/">Go to Homepage</InternalLinkButton>
      </div>
    </ErrorLayout>
  )
}
